import Request from "../../shared/utils/_request";

class Hrmanage {
  constructor() {}
  //客户管理列表接口
  getList(payload) {
    return Request.post("company/HrCompanyContacter/get-list", payload);
  }

  //添加HR接口
  addHr(payload) {
    return Request.post("company/HrCompanyContacter/create", payload);
  }

  //编辑HR接口
  editHr(payload) {
    return Request.post("company/HrCompanyContacter/update", payload);
  }

  //编辑HR详情
  getDetail(payload) {
    return Request.post("company/HrCompanyContacter/detail", payload);
  }

  //搜索公司
  searchCompany(payload) {
    return Request.post("company/suggest", payload);
  }
  //搜索BD
  searchBD(payload) {
    return Request.post("account/suggest", payload);
  }
}

export const hrlist = new Hrmanage();
